export default [
  {
    id: 1,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SSL_CERTIFICATE.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SSL_CERTIFICATE.CATEGORY',
    },
    views: 3400,
  },
  {
    id: 2,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FIRST_PORTAL.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: {
      slug: 'onboarding',
      icon: '🧑‍🍳',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FIRST_PORTAL.CATEGORY',
    },
    views: 400,
  },
  {
    id: 3,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.ORGANIZING_CONTENT.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: {
      slug: 'best-practices',
      icon: '⛺️',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.ORGANIZING_CONTENT.CATEGORY',
    },
    views: 400,
  },
  {
    id: 4,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.CUSTOMIZING_APPEARANCE.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: {
      slug: 'design',
      icon: '🎨',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.CUSTOMIZING_APPEARANCE.CATEGORY',
    },
    views: 400,
  },
  {
    id: 5,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.THIRD_PARTY_TOOLS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.THIRD_PARTY_TOOLS.CATEGORY',
    },
    views: 2800,
  },
  {
    id: 6,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.USER_PERMISSIONS.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.USER_PERMISSIONS.CATEGORY',
    },
    views: 1200,
  },
  {
    id: 7,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FAQ_SECTIONS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FAQ_SECTIONS.CATEGORY',
    },
    views: 5600,
  },
  {
    id: 8,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SEARCH_FUNCTIONALITY.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SEARCH_FUNCTIONALITY.CATEGORY',
    },
    views: 1800,
  },
  {
    id: 9,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.USAGE_METRICS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.USAGE_METRICS.CATEGORY',
    },
    views: 3200,
  },
  {
    id: 10,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.MULTILINGUAL_SUPPORT.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.MULTILINGUAL_SUPPORT.CATEGORY',
    },
    views: 900,
  },
  {
    id: 11,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.INTERACTIVE_TUTORIALS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.INTERACTIVE_TUTORIALS.CATEGORY',
    },
    views: 4100,
  },
  {
    id: 12,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FEEDBACK_SYSTEM.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.FEEDBACK_SYSTEM.CATEGORY',
    },
    views: 750,
  },
  {
    id: 13,
    titleKey: 'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SEO_CONTENT.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.SEO_CONTENT.CATEGORY',
    },
    views: 2900,
  },
  {
    id: 14,
    titleKey:
      'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.INTERNAL_KNOWLEDGE_BASE.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      nameKey:
        'HELP_CENTER.ARTICLES_PAGE.EMPTY_STATE_CONTENT.INTERNAL_KNOWLEDGE_BASE.CATEGORY',
    },
    views: 1500,
  },
];
